import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';
import { formatDate } from '../../utils/dateUtils';

const medalColor = (idx) => {
  if (idx === 0) return '#FFD700';
  if (idx === 1) return '#C0C0C0';
  if (idx === 2) return '#CD7F32';
  return null;
};

const PricesHistoryListComponent = ({ data = [] }) => {
  if (!data.length) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <EmojiEventsIcon sx={{ fontSize: 48, color: 'rgba(255,255,255,0.15)', mb: 2 }} />
        <Typography sx={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.95rem' }}>
          No prizes yet
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {data.map((item, idx) => {
        const color = medalColor(idx);
        return (
          <Box
            key={item.id ?? idx}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              p: 2,
              borderRadius: 3,
              background: 'rgba(255,255,255,0.03)',
              border: `1px solid ${color ? `${color}33` : 'rgba(255,255,255,0.07)'}`,
              transition: 'background 0.15s, border-color 0.15s',
              '&:hover': {
                background: 'rgba(255,255,255,0.06)',
                border: `1px solid ${color ?? DEFAULT_THEME_COLOR}55`,
              },
            }}
          >
            {/* Rank */}
            <Box
              sx={{
                width: 32,
                textAlign: 'center',
                flexShrink: 0,
              }}
            >
              {color ? (
                <EmojiEventsIcon sx={{ color, fontSize: 22 }} />
              ) : (
                <Typography sx={{ color: 'rgba(255,255,255,0.3)', fontSize: '0.8rem', fontWeight: 700 }}>
                  #{idx + 1}
                </Typography>
              )}
            </Box>

            {/* Avatar */}
            <Avatar
              alt={item.id}
              src={item.imageUrl || './logo-circle.png'}
              sx={{
                width: 48,
                height: 48,
                flexShrink: 0,
                border: `2px solid ${color ?? DEFAULT_THEME_COLOR}55`,
              }}
            />

            {/* Content */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                sx={{
                  color: 'white',
                  fontSize: '0.9rem',
                  fontWeight: 500,
                  lineHeight: 1.4,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                }}
              >
                {item.shakePrice?.description}
              </Typography>
              <Typography sx={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.75rem', mt: 0.5 }}>
                {formatDate(item?.createdAt)}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default PricesHistoryListComponent;
